import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { TrackingEvent } from '@app/models/tracking-event';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseTrackingService {

  abstract trackRouterEvent(event: NavigationEnd): void;

  abstract trackEvent(event: TrackingEvent): void;

  abstract trackException(): void;
}
